import React from "react";
import { motion } from "framer-motion"; // Import Framer Motion for animations
import { learningPathTwo } from "data/learningPaths";

export default function LearningPath() {
  // Define animation variants for different effects
  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }, // Decreased duration
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Faster stagger effect between children
      },
    },
  };

  return (
    <motion.section
      className="layout-pt-md layout-pb-md flex justify-center items-center"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }} // Trigger animation when 20% of the section is in view
      variants={staggerContainer} // Apply stagger effect to child elements
    >
      <div className="container mx-auto md:mt-48 lg:mt-[inherit]">
        <div className="row justify-center text-center">
          <motion.div
            className="col-auto"
            variants={fadeInUp} // Apply fade-in-up animation to the title and description
          >
            <div className="sectionTitle ">
              <h2 className="sectionTitle__title justify-center">
                Together Towards Your Medical{" "}
                <span className="text-[#FF9245]">Career</span>
              </h2>
              <p className="sectionTitle__text">
                Tailored assistance from NEET Counselling to your Admission,
                leading you on the path to your medical career.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pt-15 lg:pt-14 justify-center"
          variants={staggerContainer} // Apply stagger effect to the course cards
        >
          {learningPathTwo.map((elm, i) => (
            <motion.div
              key={i}
              className="col-lg-3 col-md-6"
              variants={fadeInUp} // Apply fade-in-up animation to each course card
              whileHover={{ scale: 1.05 }} // Slightly scale up the card on hover
            >
              <div className="coursesCard -type-3 text-center">
                <div
                  className={`coursesCard__icon rounded-full bg-opacity-10 ${
                    elm.bgColor ? elm.bgColor : " bg-green-3"
                  } flex justify-center items-center w-[100px] h-[100px]`}
                >
                  <img src={elm.icon} alt="icon" width={50} height={50} loading="lazy" />
                </div>

                <div className="coursesCard__content  mt-30 ">
                  <h3 className="coursesCard__title text-18 lh-1 fw-500">
                    {elm.title}
                  </h3>
                  <p className="coursesCard__text text-14 mt-10">{elm.text}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
}
